"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFirebaseAuth = exports.resetSupabase = exports.getSupabase = exports.initSupabaseWithAuth = exports.initSupabase = void 0;
// Client
var client_1 = require("./client");
Object.defineProperty(exports, "initSupabase", { enumerable: true, get: function () { return client_1.initSupabase; } });
Object.defineProperty(exports, "initSupabaseWithAuth", { enumerable: true, get: function () { return client_1.initSupabaseWithAuth; } });
Object.defineProperty(exports, "getSupabase", { enumerable: true, get: function () { return client_1.getSupabase; } });
Object.defineProperty(exports, "resetSupabase", { enumerable: true, get: function () { return client_1.resetSupabase; } });
Object.defineProperty(exports, "setFirebaseAuth", { enumerable: true, get: function () { return client_1.setFirebaseAuth; } });
// Types
__exportStar(require("./types"), exports);
// Repositories
__exportStar(require("./repositories"), exports);
